module.exports = __webpack_public_path__ + "static/media/user-minus.17647453.svg";